import * as types from './types';
export default {
  [types.SET_LOOKBOOK](state, payload) {
    var currentState = state;
    currentState.lookbook = payload;
  },
  [types.APPEND_AMBIENCES](state, payload) {
    var currentState = state;
    var ambiences = currentState.lookbook.items;
    currentState.lookbook.items = [...ambiences, ...payload.items];
  },
  [types.PREPEND_AMBIENCES](state, payload) {
    var currentState = state;
    var ambiences = currentState.lookbook.items;
    currentState.lookbook.items = [...payload.items, ...ambiences];
  },
  [types.SET_LOADING_AMBIENCES](state, payload) {
    var currentState = state;
    currentState.loading = payload;
  }
};